/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { CustomOutputLogBase } from './CustomOutputLogBase';
const CustomOutputLogParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['points', /* #__PURE__ */ codecOptional(codecNumber)],
    ['haystack', /* #__PURE__ */ codecOptional(codecString)],
]), CustomOutputLogBase);
export class CustomOutputLog extends CustomOutputLogBase {
    static decode(input) {
        return CustomOutputLogParser.decode(input).map(res => new CustomOutputLog(res));
    }
    static unsafeDecode(input) {
        return CustomOutputLog.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CustomOutputLogParser.encode(data);
    }
    static schema() {
        return CustomOutputLogParser.schema();
    }
}
